<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>CEMP</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">HOME </a></li>
                                <li class="breadcrumb-item active">CEMP</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12  wow fadeInDown"
                            v-if="(leveluser == 0) || (leveluser == 1) || (leveluser == 4)">
                            <div class="card collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>Import Data Excel</label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="col-sm-12">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left"
                                                    title="Unduh master excel.." @click="G_tableCSV('_CEMP_')">
                                                    <i class="fas fa-download"></i> Unduh Master Data CEMP .xlsx
                                                </button>
                                            </a>
                                        </div>
                                        <!--IKON PETA 1-->
                                        <div class="col-sm-12">
                                            <label>Pilih File<small class="text-info"> (*.xlsx)</small>
                                            </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="far fa-file-image"></i></span>
                                                </div>
                                                <input type="file" class="form-control form-control-sm"
                                                    id="fileToUploadfilenya_excel" name="fileToUploadfilenya_excel"
                                                    placeholder="fileToUpload" style="font-size: smaller;"
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    @change="onChange">
                                                <input type="hidden" class="form-control form-control-sm"
                                                    id="filenya_excel" name="filenya_excel" placeholder="File Excel">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Opsi</label>
                                            <div class="row">
                                                <div class="col-sm-10">
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar" aria-valuenow="0"
                                                            aria-valuemin="0" aria-valuemax="100" style="width:0%"
                                                            id="persennyafilenya_excel">
                                                            <span id="tulisanpersenfilenya_excel">0%</span>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <span class="text-success" id="suksesnyafilenya_excel"></span>
                                                </div>
                                                <div class="col-sm-2 text-center" v-if="tempjumlah > 0">
                                                    <button type="button"
                                                        class="btn btn-warning btn-sm lebar text-white"
                                                        @click="uploadsavedata()">
                                                        Simpan ke DB
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <!--IKON PETA 1 END-->
                                        <div class="col-sm-12">
                                            Jumlah Data excel siap Import: {{ tempjumlah }}
                                            <span style="float: right;">Jumlah Data excel Tersimpan di DB: {{
                                                tempjumlahdb
                                                }}</span>
                                            <div class="table-responsive table-wrapper" v-if="tempjumlah > 0">
                                                <table class="table m-0" id="tabeldata2">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Urut
                                                            </th>
                                                            <template v-for="(dataheader, urutheader) in tempheader"
                                                                :key="urutheader">
                                                                <th>
                                                                    {{ dataheader }}
                                                                </th>
                                                            </template>
                                                        </tr>
                                                    </thead>
                                                    <template v-for="(datadata, urutdata) in tempdata" :key="urutdata">
                                                        <tr>
                                                            <td>{{ urutdata + 1 }}</td>
                                                            <td v-for="(isidata, urutisi) in datadata" :key="urutisi">
                                                                {{ isidata }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>Filter Kolom</label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body px-3">
                                    <div class="row">
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxStatusKegiatan"
                                                    value="optionStatusKegiatan"
                                                    @click="showColumnStatusKegiatan = !showColumnStatusKegiatan">
                                                <label for="customCheckboxStatusKegiatan" class="custom-control-label">
                                                    Status Kegiatan</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxOuput" value="optionOuput"
                                                    @click="showColumnOuput = !showColumnOuput">
                                                <label for="customCheckboxOuput" class="custom-control-label">
                                                    Ouput</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxPHOFHO" value="optionPHOFHO"
                                                    @click="showColumnPHOFHO = !showColumnPHOFHO">
                                                <label for="customCheckboxPHOFHO" class="custom-control-label">
                                                    PHP / FHO</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxTarget" value="optionTarget"
                                                    @click="showColumnTarget = !showColumnTarget">
                                                <label for="customCheckboxTarget" class="custom-control-label">
                                                    Target Fisik</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxRealisasi" value="optionRealisasi"
                                                    @click="showColumnRealisasi = !showColumnRealisasi">
                                                <label for="customCheckboxRealisasi" class="custom-control-label">
                                                    Realisasi Fisik</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxDeviasi" value="optionDeviasi"
                                                    @click="showColumnDeviasi = !showColumnDeviasi">
                                                <label for="customCheckboxDeviasi" class="custom-control-label">
                                                    Deviasi Fisik</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxRealisasiKeuangan"
                                                    value="optionRealisasiKeuangan"
                                                    @click="showColumnRealisasiKeuangan = !showColumnRealisasiKeuangan">
                                                <label for="customCheckboxRealisasiKeuangan"
                                                    class="custom-control-label">
                                                    Realisasi Keu.</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxProgresKeuangan"
                                                    value="optionProgresKeuangan"
                                                    @click="showColumnProgresKeuangan = !showColumnProgresKeuangan">
                                                <label for="customCheckboxProgresKeuangan" class="custom-control-label">
                                                    Progres Keu.</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxStatus" value="optionStatus"
                                                    @click="showColumnStatus = !showColumnStatus">
                                                <label for="customCheckboxStatus" class="custom-control-label">
                                                    Status Keu.</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxPenyedia" value="optionPenyedia"
                                                    @click="showColumnPenyedia = !showColumnPenyedia" checked>
                                                <label for="customCheckboxPenyedia" class="custom-control-label">
                                                    Penyedia</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxMulai" value="optionMulai"
                                                    @click="showColumnMulai = !showColumnMulai">
                                                <label for="customCheckboxMulai" class="custom-control-label">
                                                    Mulai</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxSelesai" value="optionSelesai"
                                                    @click="showColumnSelesai = !showColumnSelesai">
                                                <label for="customCheckboxSelesai" class="custom-control-label">
                                                    Selesai</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxDurasi" value="optionDurasi"
                                                    @click="showColumnDurasi = !showColumnDurasi">
                                                <label for="customCheckboxDurasi" class="custom-control-label">
                                                    Durasi</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxKontrak" value="optionKontrak"
                                                    @click="showColumnKontrak = !showColumnKontrak">
                                                <label for="customCheckboxKontrak" class="custom-control-label">
                                                    No Kontrak</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxAdendum" value="optionAdendum"
                                                    @click="showColumnAdendum = !showColumnAdendum">
                                                <label for="customCheckboxAdendum" class="custom-control-label">
                                                    Adendum</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxNilaiKontrak"
                                                    value="optionNilaiKontrak"
                                                    @click="showColumnNilaiKontrak = !showColumnNilaiKontrak">
                                                <label for="customCheckboxNilaiKontrak" class="custom-control-label">
                                                    Nlai Kontrak</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxBerjalan" value="optionBerjalan"
                                                    @click="showColumnBerjalan = !showColumnBerjalan">
                                                <label for="customCheckboxBerjalan" class="custom-control-label">
                                                    Durasi Berjalan</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxTersisa" value="optionTersisa"
                                                    @click="showColumnTersisa = !showColumnTersisa">
                                                <label for="customCheckboxTersisa" class="custom-control-label">
                                                    Durasi Tersisa</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                    <div class="col-sm-12 float-left pb-2">&nbsp;</div>
                                    <div class="col-sm-12 float-left pb-2 px-3 wow fadeInDown">
                                        Jumlah Data {{ G_numFormat(jumlahdata) }}
                                        <span style="float: right;">
                                            <span>Halaman ke: </span>
                                            <select v-model="halaman" @change="onChangeHalaman($event)">
                                                <option v-for="index in jumlahhalaman" :key="index">
                                                    {{ index }}</option>
                                            </select>
                                            <span> dari </span> {{ jumlahhalaman }}
                                        </span>
                                    </div>
                                    <div class="col-sm-12 float-left pb-2">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian" @keyup="ambildata()">
                                    </div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata" style="font-size: small;">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;" rowspan="3">No</th>
                                                    <th style="width: 100px;" rowspan="3">PIU</th>
                                                    <th style="width: 100px;" rowspan="3">Kegiatan</th>
                                                    <th style="width: 100px;" rowspan="3"
                                                        v-if="showColumnStatusKegiatan">Status<br>Kegiatan</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnOuput">Ouput
                                                    </th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnPHOFHO">
                                                        Status<br>PHO/FHO</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnPHOFHO">
                                                        Tanggal<br>PHO/FHO</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnTarget">
                                                        Target<br>Fisik (%)</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnRealisasi">
                                                        Realisasi<br>Fisik (%)</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnDeviasi">
                                                        Deviasi<br>Fisik (%)</th>
                                                    <th style="width: 50px;" rowspan="3"
                                                        v-if="showColumnRealisasiKeuangan">
                                                        Realisasi<br>Keuangan<br>Kumulatif<br>(Rp.)</th>
                                                    <th style="width: 50px;" rowspan="3"
                                                        v-if="showColumnProgresKeuangan">Progres<br>Keuangan (%)</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnStatus">
                                                        Status<br>Penyerapan<br>Anggaran</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnPenyedia">
                                                        Penyedia</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnMulai">Mulai
                                                    </th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnSelesai">
                                                        Selesai</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnDurasi">
                                                        Durasi<br>(Bulan)</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnKontrak">Nomor
                                                        Kontrak</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnAdendum">
                                                        Adendum</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnNilaiKontrak">
                                                        Nilai Kontrak<br>(Rp.)</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnBerjalan">
                                                        Waktu<br>Durasi<br>Berjalan<br>(%)</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnTersisa">
                                                        Waktu<br>Durasi<br>Tersisa<br>(%)</th>
                                                    <th style="width: 50px;" rowspan="3">
                                                        Status<br>Laporan<br>CEMP</th>
                                                    <th style="width: 50px;" rowspan="3">
                                                        Tanggal<br>Laporan<br>CEMP</th>
                                                    <th style="width: 50px;" :colspan="colspan">
                                                        Laporan CEMP Tahun</th>
                                                </tr>
                                                <tr>
                                                    <th v-for="(listtahun, uruttahun) in datatahun" :colspan="8" :id="'kolomtahun'+listtahun">
                                                        {{ listtahun }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <template v-for="(listtahun, uruttahun) in datatahun">
                                                        <th>Status<br>Laporan<br>Implementasi<br>Semester 1</th>
                                                        <th>Tanggal<br>Penyerahan<br>Laporan<br>Implementasi<br>CEMP<br>Ke
                                                            PMSC<br>Semester 1</th>
                                                        <th>Status<br>Laporan<br>PPK <br>Semester 1</th>
                                                        <th>Tanggal<br>Penyerahan<br>Laporan<br>Implementasi<br>CEMP<br>Ke
                                                            PPK<br>Semester 1</th>
                                                        <th>Status<br>Laporan<br>Implementasi<br>Semester 2</th>
                                                        <th>Tanggal<br>Penyerahan<br>Laporan<br>Implementasi<br>CEMP<br>Ke
                                                            PMSC<br>Semester 2</th>
                                                        <th>Status<br>Laporan<br>PPK <br>Semester 2</th>
                                                        <th>Tanggal<br>Penyerahan<br>Laporan<br>Implementasi<br>CEMP<br>Ke
                                                            PPK<br>Semester 2</th>
                                                    </template>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center">{{ urutlist + 1 }}</td>
                                                        <td>
                                                            {{ datalist.nama_satker }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.Nama_Kegiatan }}
                                                        </td>
                                                        <td v-if="showColumnStatusKegiatan">
                                                            {{ datalist.Status_pekerjaan }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnOuput">
                                                            {{ datalist.Komponen }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnPHOFHO">
                                                            {{ datalist.PHO_FHO }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnPHOFHO">
                                                            {{ G_formatDateNonWIB(datalist.tanggalPHO_FHO) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnTarget">
                                                            {{ G_numKoma(datalist.TARGET) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnRealisasi">
                                                            {{ G_numKoma(datalist.PROGRES) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnDeviasi">
                                                            {{ G_numKoma(datalist.DEVIASI) }}
                                                        </td>
                                                        <td class="text-right" v-if="showColumnRealisasiKeuangan">
                                                            {{ G_numFormat(datalist.REALISASI_KUMULATIF) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnProgresKeuangan">
                                                            {{ G_numKoma(datalist.PROGRESKEUANGAN) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnStatus">
                                                            {{ datalist.STATUS_KEU_PROYEK }}
                                                        </td>
                                                        <td class="text-justify" v-if="showColumnPenyedia">
                                                            {{ datalist.KONTRAKTOR }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnMulai">
                                                            {{ G_formatDateNonWIB(datalist.MULAI) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnSelesai">
                                                            {{ G_formatDateNonWIB(datalist.SELESAI) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnDurasi">
                                                            {{ G_numKoma(datalist.BULAN) }}
                                                        </td>
                                                        <td class="text-justify" v-if="showColumnKontrak">
                                                            {{ datalist.NOKONTRAK }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnAdendum">
                                                            {{ datalist.ADENDUM }}
                                                        </td>
                                                        <td class="text-right" v-if="showColumnNilaiKontrak">
                                                            {{ G_numFormat(datalist.NILAIKONTRAK) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnBerjalan">
                                                            {{ G_numKoma(datalist.DURASI) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnTersisa">
                                                            {{ G_numKoma(datalist.DURASITERSISA) }}
                                                        </td>
                                                        <td class="text-justify">
                                                            {{ datalist.C_EMP_Status }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ datalist.C_EMP_Date }}
                                                        </td>
                                                        <template v-for="(listlaporan, urutlaporan) in datalist.Laporan"
                                                            :key="urutlaporan">
                                                            <td>
                                                                {{ listlaporan.Status_C_EMP_Sem_1 }}
                                                            </td>
                                                            <td>
                                                                {{ G_formatDateNonWIB(listlaporan.Date_C_EMP_Sem_1) }}
                                                            </td>
                                                            <td>
                                                                {{ listlaporan.Status_C_EMP_PPK_Sem_1 }}
                                                            </td>
                                                            <td>
                                                                {{ G_formatDateNonWIB(listlaporan.Date_C_EMP_PPK_Sem_1) }}
                                                            </td>
                                                            <td>
                                                                {{ listlaporan.Status_C_EMP_Sem_2 }}
                                                            </td>
                                                            <td>
                                                                {{ G_formatDateNonWIB(listlaporan.Date_C_EMP_Sem_2) }}
                                                            </td>
                                                            <td>
                                                                {{ listlaporan.Status_C_EMP_PPK_Sem_2 }}
                                                            </td>
                                                            <td>
                                                                {{ G_formatDateNonWIB(listlaporan.Date_C_EMP_PPK_Sem_2) }}
                                                            </td>
                                                        </template>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    Data masih kosong
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import readXlsxFile from 'read-excel-file';
import CryptoJS from 'crypto-js';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            tahunaktif: new Date().getFullYear(),
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            datapesan: '',
            datamaster: [],
            carikata: '',
            colspan: 8,
            datatahun: [],
            showColumnStatusKegiatan: false,
            showColumnOuput: false,
            showColumnPHOFHO: false,
            showColumnTarget: false,
            showColumnRealisasi: false,
            showColumnDeviasi: false,
            showColumnRealisasiKeuangan: false,
            showColumnProgresKeuangan: false,
            showColumnStatus: false,
            showColumnPenyedia: true,
            showColumnMulai: false,
            showColumnSelesai: false,
            showColumnDurasi: false,
            showColumnKontrak: false,
            showColumnNilaiKontrak: false,
            showColumnAdendum: false,
            showColumnBerjalan: false,
            showColumnTersisa: false,
            project_id: process.env.VUE_APP_PROJECT_ID,
            tempexcel: [],
            ekportexcel: [],
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        async G_tableCSV(namefile) {
            this.ekportexcel = [];
            this.halamanloading = true;
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonev-AllCEMP?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.tempexcel = [];
                        this.tempexcel = Response.data.content.data;
                        for (let i = 0; i < this.tempexcel.length; i++) {
                            this.ekportexcel.push({
                                "No": this.tempexcel[i].id_kegiatan,
                                "PIU": this.tempexcel[i].nama_satker,
                                "Nama Kegiatan": this.tempexcel[i].Nama_Kegiatan,
                                "KONTRAKTOR / PENYEDIA": this.tempexcel[i].KONTRAKTOR,
                                "Status Laporan CEMP": this.tempexcel[i].C_EMP_Status,
                                "Tanggal Laporan CEMP": this.tempexcel[i].C_EMP_Date,
                                "Status Laporan Implementasi CEMP Semester 1 Tahun 2019": this.tempexcel[i].Laporan[0].Status_C_EMP_Sem_1,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 1 Ke PMSC Tahun 2019": this.tempexcel[i].Laporan[0].Date_C_EMP_Sem_1,
                                "Status Laporan CEMP Ke PPK Semester 1 Tahun 2019": this.tempexcel[i].Laporan[0].Status_C_EMP_PPK_Sem_1,
                                "Tanggal Penyerahan Laporan CEMP Semester 1 Ke PPK Tahun 2019": this.tempexcel[i].Laporan[0].Date_C_EMP_PPK_Sem_1,
                                "Status Laporan Implementasi CEMP Semester 2 Tahun 2019": this.tempexcel[i].Laporan[0].Status_C_EMP_Sem_2,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 2 Ke PMSC Tahun 2019": this.tempexcel[i].Laporan[0].Date_C_EMP_Sem_2,
                                "Status Laporan CEMP Ke PPK Semester 2 Tahun 2019": this.tempexcel[i].Laporan[0].Status_C_EMP_PPK_Sem_2,
                                "Tanggal Penyerahan Laporan CEMP Semester 2 Ke PPK Tahun 2019": this.tempexcel[i].Laporan[0].Date_C_EMP_PPK_Sem_2,

                                "Status Laporan Implementasi CEMP Semester 1 Tahun 2020": this.tempexcel[i].Laporan[1].Status_C_EMP_Sem_1,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 1 Ke PMSC Tahun 2020": this.tempexcel[i].Laporan[1].Date_C_EMP_Sem_1,
                                "Status Laporan CEMP Ke PPK Semester 1 Tahun 2020": this.tempexcel[i].Laporan[1].Status_C_EMP_PPK_Sem_1,
                                "Tanggal Penyerahan Laporan CEMP Semester 1 Ke PPK Tahun 2020": this.tempexcel[i].Laporan[1].Date_C_EMP_PPK_Sem_1,
                                "Status Laporan Implementasi CEMP Semester 2 Tahun 2020": this.tempexcel[i].Laporan[1].Status_C_EMP_Sem_2,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 2 Ke PMSC Tahun 2020": this.tempexcel[i].Laporan[1].Date_C_EMP_Sem_2,
                                "Status Laporan CEMP Ke PPK Semester 2 Tahun 2020": this.tempexcel[i].Laporan[1].Status_C_EMP_PPK_Sem_2,
                                "Tanggal Penyerahan Laporan CEMP Semester 2 Ke PPK Tahun 2020": this.tempexcel[i].Laporan[1].Date_C_EMP_PPK_Sem_2,

                                "Status Laporan Implementasi CEMP Semester 1 Tahun 2021": this.tempexcel[i].Laporan[2].Status_C_EMP_Sem_1,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 1 Ke PMSC Tahun 2021": this.tempexcel[i].Laporan[2].Date_C_EMP_Sem_1,
                                "Status Laporan CEMP Ke PPK Semester 1 Tahun 2021": this.tempexcel[i].Laporan[2].Status_C_EMP_PPK_Sem_1,
                                "Tanggal Penyerahan Laporan CEMP Semester 1 Ke PPK Tahun 2021": this.tempexcel[i].Laporan[2].Date_C_EMP_PPK_Sem_1,
                                "Status Laporan Implementasi CEMP Semester 2 Tahun 2021": this.tempexcel[i].Laporan[2].Status_C_EMP_Sem_2,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 2 Ke PMSC Tahun 2021": this.tempexcel[i].Laporan[2].Date_C_EMP_Sem_2,
                                "Status Laporan CEMP Ke PPK Semester 2 Tahun 2021": this.tempexcel[i].Laporan[2].Status_C_EMP_PPK_Sem_2,
                                "Tanggal Penyerahan Laporan CEMP Semester 2 Ke PPK Tahun 2021": this.tempexcel[i].Laporan[2].Date_C_EMP_PPK_Sem_2,

                                "Status Laporan Implementasi CEMP Semester 1 Tahun 2022": this.tempexcel[i].Laporan[3].Status_C_EMP_Sem_1,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 1 Ke PMSC Tahun 2022": this.tempexcel[i].Laporan[3].Date_C_EMP_Sem_1,
                                "Status Laporan CEMP Ke PPK Semester 1 Tahun 2022": this.tempexcel[i].Laporan[3].Status_C_EMP_PPK_Sem_1,
                                "Tanggal Penyerahan Laporan CEMP Semester 1 Ke PPK Tahun 2022": this.tempexcel[i].Laporan[3].Date_C_EMP_PPK_Sem_1,
                                "Status Laporan Implementasi CEMP Semester 2 Tahun 2022": this.tempexcel[i].Laporan[3].Status_C_EMP_Sem_2,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 2 Ke PMSC Tahun 2022": this.tempexcel[i].Laporan[3].Date_C_EMP_Sem_2,
                                "Status Laporan CEMP Ke PPK Semester 2 Tahun 2022": this.tempexcel[i].Laporan[3].Status_C_EMP_PPK_Sem_2,
                                "Tanggal Penyerahan Laporan CEMP Semester 2 Ke PPK Tahun 2022": this.tempexcel[i].Laporan[3].Date_C_EMP_PPK_Sem_2,

                                "Status Laporan Implementasi CEMP Semester 1 Tahun 2023": this.tempexcel[i].Laporan[4].Status_C_EMP_Sem_1,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 1 Ke PMSC Tahun 2023": this.tempexcel[i].Laporan[4].Date_C_EMP_Sem_1,
                                "Status Laporan CEMP Ke PPK Semester 1 Tahun 2023": this.tempexcel[i].Laporan[4].Status_C_EMP_PPK_Sem_1,
                                "Tanggal Penyerahan Laporan CEMP Semester 1 Ke PPK Tahun 2023": this.tempexcel[i].Laporan[4].Date_C_EMP_PPK_Sem_1,
                                "Status Laporan Implementasi CEMP Semester 2 Tahun 2023": this.tempexcel[i].Laporan[4].Status_C_EMP_Sem_2,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 2 Ke PMSC Tahun 2023": this.tempexcel[i].Laporan[4].Date_C_EMP_Sem_2,
                                "Status Laporan CEMP Ke PPK Semester 2 Tahun 2023": this.tempexcel[i].Laporan[4].Status_C_EMP_PPK_Sem_2,
                                "Tanggal Penyerahan Laporan CEMP Semester 2 Ke PPK Tahun 2023": this.tempexcel[i].Laporan[4].Date_C_EMP_PPK_Sem_2,

                                "Status Laporan Implementasi CEMP Semester 1 Tahun 2024": this.tempexcel[i].Laporan[5].Status_C_EMP_Sem_1,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 1 Ke PMSC Tahun 2024": this.tempexcel[i].Laporan[5].Date_C_EMP_Sem_1,
                                "Status Laporan CEMP Ke PPK Semester 1 Tahun 2024": this.tempexcel[i].Laporan[5].Status_C_EMP_PPK_Sem_1,
                                "Tanggal Penyerahan Laporan CEMP Semester 1 Ke PPK Tahun 2024": this.tempexcel[i].Laporan[5].Date_C_EMP_PPK_Sem_1,
                                "Status Laporan Implementasi CEMP Semester 2 Tahun 2024": this.tempexcel[i].Laporan[5].Status_C_EMP_Sem_2,
                                "Tanggal Penyerahan Laporan Implementasi CEMP Semester 2 Ke PMSC Tahun 2024": this.tempexcel[i].Laporan[5].Date_C_EMP_Sem_2,
                                "Status Laporan CEMP Ke PPK Semester 2 Tahun 2024": this.tempexcel[i].Laporan[5].Status_C_EMP_PPK_Sem_2,
                                "Tanggal Penyerahan Laporan CEMP Semester 2 Ke PPK Tahun 2024": this.tempexcel[i].Laporan[5].Date_C_EMP_PPK_Sem_2,
                            });
                        }
                        function formatColumn(worksheet, col, fmt) {
                            const range = XLSX.utils.decode_range(worksheet['!ref'])
                            // note: range.s.r + 1 skips the header row
                            for (let row = range.s.r + 1; row <= range.e.r; ++row) {
                                const ref = XLSX.utils.encode_cell({ r: row, c: col })
                                if (worksheet[ref] && worksheet[ref].t === 'n') {
                                    worksheet[ref].z = fmt
                                }
                            }
                        }
                        const currency = '0.00';
                        const XLSX = xlsx;
                        const workbook = XLSX.utils.book_new();
                        const worksheet = XLSX.utils.json_to_sheet(this.ekportexcel);

                        // ARRAY NUMBER SILAHKAN MASUKKAN NOMOR KOLOM
                        for (let col of []) {
                            formatColumn(worksheet, col, currency)
                        }
                        XLSX.utils.book_append_sheet(workbook, worksheet, "CEMP");
                        XLSX.writeFile(workbook, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
                        this.halamanloading = false;
                    }
                    else {
                        this.tempexcel = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
            //console.log(this.datamaster);
            //return false;
        },
        onChange(event) {
            this.tempjumlahdb = 0;
            try {
                if (event.target.files[0]['type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    this.file = event.target.files ? event.target.files[0] : null;
                    if (this.file) {
                        this.tempheader = [];
                        this.tempdata = [];
                        readXlsxFile(this.file).then((rows) => {
                            // `rows` is an array of rows
                            // each row being an array of cells.
                            //alert(rows.length);
                            this.halamanloading = true;
                            this.tempjumlah = rows.length - 1;
                            //alert(this.tempjumlah);
                            for (let i = 0; i < rows.length; i++) {
                                this.halamanloading = true;
                                if (i == 0) {
                                    var varheader = rows[i];
                                    for (let x = 0; x < varheader.length; x++) {
                                        this.tempheader.push(varheader[x]);
                                    }
                                }
                                else {
                                    this.tempdata.push(rows[i]);
                                }
                                document.getElementById('persennyafilenya_excel').style.width = Math.round((i / (rows.length - 1)) * 100) + "%";
                                document.getElementById('tulisanpersenfilenya_excel').innerHTML = Math.round((i / (rows.length - 1)) * 100) + "%";
                            }
                            //alert(JSON.stringify(this.tempheader));
                            //console.log(this.tempdata);
                            this.halamanloading = false;
                        })
                    }
                }
                else {
                    swal.fire('Peringatan', 'File tidak sesuai format', 'error');
                    return false;
                }
            } catch (error) {

            }

        },
        async uploadsavedata() {
            this.tempjumlahdb = 0;
            var tempheader = this.tempheader;
            //console.log(JSON.stringify(this.tempdata));
            //alert(this.tempdata.length);
            //return false;
            var temparraydata = ''
            for (let i = 0; i < this.tempdata.length; i++) {
                var data = "";
                for (let x = 0; x < this.tempdata[i].length; x++) {
                    if (x == 0) {
                        data = this.tempdata[i][x];
                    }
                    else {
                        data = data + '|' + this.tempdata[i][x];
                    }
                }
                if (i == 0) {
                    temparraydata = temparraydata + data;
                }
                else {
                    temparraydata = temparraydata + '|+|' + data;
                }
            }
            //console.log(temparraydata);
            //return false;
            var fd = new FormData();
            fd.append("tempheader", tempheader);
            fd.append("data", temparraydata);
            fd.append("project_id", this.project_id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            this.halamanloading = true;
            await mainAPI.post("parastapainnovation_excelCEMP-SaveCEMP", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        this.halamanloading = false;
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        this.halamanloading = false;
                        swal.fire('Informasi', 'Data telah diimport..', 'success').then(function () {
                            window.location.replace("/CEMP");
                        });

                    }
                }
            ).catch(function (error) {
                this.halamanloading = false;
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            //alert(tempheader);
            //alert(acuan);
            //alert(data);
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        onChangeHalaman(event) {
            this.pindahhalaman(event.target.value);
        },
        async pindahhalaman(halamannya) {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonev-GetCEMP?random=" + random + "&project_id=" + this.project_id + "&halaman=" + halamannya + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datatahun = [];
                    this.datatahun = Response.data.tahun;
                    this.colspan= this.datatahun.length * 8;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.datamaster = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            //alert(this.tahunaktif);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonev-GetCEMP?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datatahun = [];
                    this.datatahun = Response.data.tahun;
                    this.colspan= this.datatahun.length * 8;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.datamaster = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildata();
    }
}
</script>
<style></style>